import React from 'react';

type SecondaryActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  fullWidth?: boolean;
};

const SecondaryActionButton: React.FC<SecondaryActionButtonProps> = ({
  children,
  className = '',
  fullWidth = false,
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    className={`inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-3 text-sm font-semibold uppercase tracking-[0.2em] text-white transition hover:-translate-y-0.5 hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-50 ${fullWidth ? 'w-full' : ''} ${className}`.trim()}
    {...props}
  >
    {children}
  </button>
);

export default SecondaryActionButton;

